<div [formGroup]="form" class="container">
  <div class="flex-wrap">
    <mat-form-field fxFlex="25">
      <redispatch-erzeugungsanlage-form-prefix matPrefix
      [feld]="Feld.FIELD_ANSCHRIFT_ANLAGE_PLZ"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Postleitzahl</mat-label>
      <input formControlName="plz"
        data-qa="plz"
        matInput
        name="anlagenAnschrift_plz">
      @if (f.plz.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Postleitzahl ein
        </mat-error>
      }
      @if (f.plz.getError('minlength'); as error) {
        <mat-error>
          Postleitzahl zu kurz ({{ error.requiredLength }})
        </mat-error>
      }
      @if (f.plz.getError('maxlength'); as error) {
        <mat-error>
          Postleitzahl zu lang ({{ error.requiredLength }})
        </mat-error>
      }
      @if (f.plz.hasError('pattern')) {
        <mat-error>
          Bitte geben Sie eine fünfstellige Postleitzahl aus Deutschland ein
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix
      [feld]="Feld.FIELD_ANSCHRIFT_ANLAGE_GEMEINDE"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Gemeinde</mat-label>
      <input formControlName="gemeinde"
        data-qa="gemeinde"
        [maxlength]="GEMEINDE_MAX_LENGTH"
        matInput
        name="anlagenAnschrift_gemeinde">
      @if (f.gemeinde.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Gemeinde ein
        </mat-error>
      }
      @if (f.gemeinde.hasError('maxlength')) {
        <mat-error>
          Die maximale Länge beträgt {{ GEMEINDE_MAX_LENGTH }} Zeichen
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix
      [feld]="Feld.FIELD_ANSCHRIFT_ANLAGE_STRASSE"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Strasse</mat-label>
      <input formControlName="strasse"
        data-qa="strasse"
        matInput
        name="anlagenAnschrift_strasse">
    </mat-form-field>

    <mat-form-field fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix
      [feld]="Feld.FIELD_ANSCHRIFT_ANLAGE_HAUSNR"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Hausnr.</mat-label>
      <input formControlName="hausnr"
        data-qa="hausnr"
        matInput
        name="anlagenAnschrift_hausnr">
    </mat-form-field>

    <mat-form-field fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix
      [feld]="Feld.FIELD_ANSCHRIFT_ANLAGE_HAUSNR_ZUSATZ"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Hausnr.-Zusatz</mat-label>
      <input formControlName="hausnrZusatz"
        data-qa="hausnrZusatz"
        matInput
        name="anlagenAnschrift_hausnrZusatz">
    </mat-form-field>
  </div>
</div>


